import { Color as pe } from "./index.es360.js";
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function Yt() {
}
const Xt = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function I(e) {
  return e == null;
}
function T(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function m(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function de(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function Ut(e, t) {
  return de(e) ? e : t;
}
function _(e, t) {
  return typeof e > "u" ? t : e;
}
const Zt = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, Re = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function eo(e, t, o) {
  if (e && typeof e.call == "function")
    return e.apply(o, t);
}
function to(e, t, o, n) {
  let r, i, a;
  if (T(e))
    for (i = e.length, r = 0; r < i; r++)
      t.call(o, e[r], r);
  else if (m(e))
    for (a = Object.keys(e), i = a.length, r = 0; r < i; r++)
      t.call(o, e[a[r]], a[r]);
}
function oo(e, t) {
  let o, n, r, i;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (o = 0, n = e.length; o < n; ++o)
    if (r = e[o], i = t[o], r.datasetIndex !== i.datasetIndex || r.index !== i.index)
      return !1;
  return !0;
}
function z(e) {
  if (T(e))
    return e.map(z);
  if (m(e)) {
    const t = /* @__PURE__ */ Object.create(null), o = Object.keys(e), n = o.length;
    let r = 0;
    for (; r < n; ++r)
      t[o[r]] = z(e[o[r]]);
    return t;
  }
  return e;
}
function ge(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function We(e, t, o, n) {
  if (!ge(e))
    return;
  const r = t[e], i = o[e];
  m(r) && m(i) ? E(r, i, n) : t[e] = z(i);
}
function E(e, t, o) {
  const n = T(t) ? t : [
    t
  ], r = n.length;
  if (!m(e))
    return e;
  o = o || {};
  const i = o.merger || We;
  let a;
  for (let s = 0; s < r; ++s) {
    if (a = n[s], !m(a))
      continue;
    const c = Object.keys(a);
    for (let l = 0, u = c.length; l < u; ++l)
      i(c[l], e, a, o);
  }
  return e;
}
function Ae(e, t) {
  return E(e, t, {
    merger: Be
  });
}
function Be(e, t, o) {
  if (!ge(e))
    return;
  const n = t[e], r = o[e];
  m(n) && m(r) ? Ae(n, r) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = z(r));
}
const ee = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function De(e) {
  const t = e.split("."), o = [];
  let n = "";
  for (const r of t)
    n += r, n.endsWith("\\") ? n = n.slice(0, -1) + "." : (o.push(n), n = "");
  return o;
}
function Ne(e) {
  const t = De(e);
  return (o) => {
    for (const n of t) {
      if (n === "")
        break;
      o = o && o[n];
    }
    return o;
  };
}
function Le(e, t) {
  return (ee[t] || (ee[t] = Ne(t)))(e);
}
function ye(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const no = (e) => typeof e < "u", H = (e) => typeof e == "function", ro = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const o of e)
    if (!t.has(o))
      return !1;
  return !0;
};
function io(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const x = Math.PI, M = 2 * x, ze = M + x, F = Number.POSITIVE_INFINITY, Ee = x / 180, w = x / 2, k = x / 4, te = x * 2 / 3, be = Math.log10, oe = Math.sign;
function xe(e, t, o) {
  return Math.abs(e - t) < o;
}
function ao(e) {
  const t = Math.round(e);
  e = xe(e, t, e / 1e3) ? t : e;
  const o = Math.pow(10, Math.floor(be(e))), n = e / o;
  return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * o;
}
function so(e) {
  const t = [], o = Math.sqrt(e);
  let n;
  for (n = 1; n < o; n++)
    e % n === 0 && (t.push(n), t.push(e / n));
  return o === (o | 0) && t.push(o), t.sort((r, i) => r - i).pop(), t;
}
function He(e) {
  return typeof e == "symbol" || typeof e == "object" && e !== null && !(Symbol.toPrimitive in e || "toString" in e || "valueOf" in e);
}
function co(e) {
  return !He(e) && !isNaN(parseFloat(e)) && isFinite(e);
}
function lo(e, t) {
  const o = Math.round(e);
  return o - t <= e && o + t >= e;
}
function uo(e, t, o) {
  let n, r, i;
  for (n = 0, r = e.length; n < r; n++)
    i = e[n][o], isNaN(i) || (t.min = Math.min(t.min, i), t.max = Math.max(t.max, i));
}
function fo(e) {
  return e * (x / 180);
}
function ho(e) {
  return e * (180 / x);
}
function po(e) {
  if (!de(e))
    return;
  let t = 1, o = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, o++;
  return o;
}
function go(e, t) {
  const o = t.x - e.x, n = t.y - e.y, r = Math.sqrt(o * o + n * n);
  let i = Math.atan2(n, o);
  return i < -0.5 * x && (i += M), {
    angle: i,
    distance: r
  };
}
function ne(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function Fe(e, t) {
  return (e - t + ze) % M - x;
}
function v(e) {
  return (e % M + M) % M;
}
function Qe(e, t, o, n) {
  const r = v(e), i = v(t), a = v(o), s = v(i - r), c = v(a - r), l = v(r - i), u = v(r - a);
  return r === i || r === a || n && i === a || s > c && l < u;
}
function J(e, t, o) {
  return Math.max(t, Math.min(o, e));
}
function yo(e) {
  return J(e, -32768, 32767);
}
function qe(e, t, o, n = 1e-6) {
  return e >= Math.min(t, o) - n && e <= Math.max(t, o) + n;
}
function me(e, t, o) {
  o = o || ((a) => e[a] < t);
  let n = e.length - 1, r = 0, i;
  for (; n - r > 1; )
    i = r + n >> 1, o(i) ? r = i : n = i;
  return {
    lo: r,
    hi: n
  };
}
const A = (e, t, o, n) => me(e, o, n ? (r) => {
  const i = e[r][t];
  return i < o || i === o && e[r + 1][t] === o;
} : (r) => e[r][t] < o), bo = (e, t, o) => me(e, o, (n) => e[n][t] >= o), Me = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function xo(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), Me.forEach((o) => {
    const n = "_onData" + ye(o), r = e[o];
    Object.defineProperty(e, o, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const a = r.apply(this, i);
        return e._chartjs.listeners.forEach((s) => {
          typeof s[n] == "function" && s[n](...i);
        }), a;
      }
    });
  });
}
function mo(e, t) {
  const o = e._chartjs;
  if (!o)
    return;
  const n = o.listeners, r = n.indexOf(t);
  r !== -1 && n.splice(r, 1), !(n.length > 0) && (Me.forEach((i) => {
    delete e[i];
  }), delete e._chartjs);
}
function Mo(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const $e = (function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
})();
function wo(e, t) {
  let o = [], n = !1;
  return function(...r) {
    o = r, n || (n = !0, $e.call(window, () => {
      n = !1, e.apply(t, o);
    }));
  };
}
function vo(e, t) {
  let o;
  return function(...n) {
    return t ? (clearTimeout(o), o = setTimeout(e, t, n)) : e.apply(this, n), t;
  };
}
const ko = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", _o = (e, t, o) => e === "start" ? t : e === "end" ? o : (t + o) / 2, Oo = (e, t, o, n) => e === (n ? "left" : "right") ? o : e === "center" ? (t + o) / 2 : t;
function To(e, t, o) {
  const n = t.length;
  let r = 0, i = n;
  if (e._sorted) {
    const { iScale: a, vScale: s, _parsed: c } = e, l = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null, u = a.axis, { min: p, max: d, minDefined: g, maxDefined: y } = a.getUserBounds();
    if (g) {
      if (r = Math.min(
        // @ts-expect-error Need to type _parsed
        A(c, u, p).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        o ? n : A(t, u, a.getPixelForValue(p)).lo
      ), l) {
        const h = c.slice(0, r + 1).reverse().findIndex((f) => !I(f[s.axis]));
        r -= Math.max(0, h);
      }
      r = J(r, 0, n - 1);
    }
    if (y) {
      let h = Math.max(
        // @ts-expect-error Need to type _parsed
        A(c, a.axis, d, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        o ? 0 : A(t, u, a.getPixelForValue(d), !0).hi + 1
      );
      if (l) {
        const f = c.slice(h - 1).findIndex((b) => !I(b[s.axis]));
        h += Math.max(0, f);
      }
      i = J(h, r, n) - r;
    } else
      i = n - r;
  }
  return {
    start: r,
    count: i
  };
}
function Po(e) {
  const { xScale: t, yScale: o, _scaleRanges: n } = e, r = {
    xmin: t.min,
    xmax: t.max,
    ymin: o.min,
    ymax: o.max
  };
  if (!n)
    return e._scaleRanges = r, !0;
  const i = n.xmin !== t.min || n.xmax !== t.max || n.ymin !== o.min || n.ymax !== o.max;
  return Object.assign(n, r), i;
}
const B = (e) => e === 0 || e === 1, re = (e, t, o) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * M / o)), ie = (e, t, o) => Math.pow(2, -10 * e) * Math.sin((e - t) * M / o) + 1, K = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * w) + 1,
  easeOutSine: (e) => Math.sin(e * w),
  easeInOutSine: (e) => -0.5 * (Math.cos(x * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => B(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => B(e) ? e : re(e, 0.075, 0.3),
  easeOutElastic: (e) => B(e) ? e : ie(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return B(e) ? e : e < 0.5 ? 0.5 * re(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * ie(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - K.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? K.easeInBounce(e * 2) * 0.5 : K.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Y(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function So(e) {
  return Y(e) ? e : new pe(e);
}
function V(e) {
  return Y(e) ? e : new pe(e).saturate(0.5).darken(0.1).hexString();
}
const Ke = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], Ve = [
  "color",
  "borderColor",
  "backgroundColor"
];
function Ge(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: Ve
    },
    numbers: {
      type: "number",
      properties: Ke
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function Je(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const ae = /* @__PURE__ */ new Map();
function Ye(e, t) {
  t = t || {};
  const o = e + JSON.stringify(t);
  let n = ae.get(o);
  return n || (n = new Intl.NumberFormat(e, t), ae.set(o, n)), n;
}
function Xe(e, t, o) {
  return Ye(t, o).format(e);
}
const Ue = {
  values(e) {
    return T(e) ? e : "" + e;
  },
  numeric(e, t, o) {
    if (e === 0)
      return "0";
    const n = this.chart.options.locale;
    let r, i = e;
    if (o.length > 1) {
      const l = Math.max(Math.abs(o[0].value), Math.abs(o[o.length - 1].value));
      (l < 1e-4 || l > 1e15) && (r = "scientific"), i = Ze(e, o);
    }
    const a = be(Math.abs(i)), s = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), c = {
      notation: r,
      minimumFractionDigits: s,
      maximumFractionDigits: s
    };
    return Object.assign(c, this.options.ticks.format), Xe(e, n, c);
  }
};
function Ze(e, t) {
  let o = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(o) >= 1 && e !== Math.floor(e) && (o = e - Math.floor(e)), o;
}
var et = {
  formatters: Ue
};
function tt(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, o) => o.lineWidth,
      tickColor: (t, o) => o.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: et.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const ot = /* @__PURE__ */ Object.create(null), nt = /* @__PURE__ */ Object.create(null);
function W(e, t) {
  if (!t)
    return e;
  const o = t.split(".");
  for (let n = 0, r = o.length; n < r; ++n) {
    const i = o[n];
    e = e[i] || (e[i] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function G(e, t, o) {
  return typeof t == "string" ? E(W(e, t), o) : E(W(e, ""), t);
}
class rt {
  constructor(t, o) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (n) => n.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (n, r) => V(r.backgroundColor), this.hoverBorderColor = (n, r) => V(r.borderColor), this.hoverColor = (n, r) => V(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(o);
  }
  set(t, o) {
    return G(this, t, o);
  }
  get(t) {
    return W(this, t);
  }
  describe(t, o) {
    return G(nt, t, o);
  }
  override(t, o) {
    return G(ot, t, o);
  }
  route(t, o, n, r) {
    const i = W(this, t), a = W(this, n), s = "_" + o;
    Object.defineProperties(i, {
      [s]: {
        value: i[o],
        writable: !0
      },
      [o]: {
        enumerable: !0,
        get() {
          const c = this[s], l = a[r];
          return m(c) ? Object.assign({}, l, c) : _(c, l);
        },
        set(c) {
          this[s] = c;
        }
      }
    });
  }
  apply(t) {
    t.forEach((o) => o(this));
  }
}
var it = /* @__PURE__ */ new rt({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  Ge,
  Je,
  tt
]);
function at(e) {
  return !e || I(e.size) || I(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function Co(e, t, o, n, r) {
  let i = t[r];
  return i || (i = t[r] = e.measureText(r).width, o.push(r)), i > n && (n = i), n;
}
function Io(e, t, o) {
  const n = e.currentDevicePixelRatio, r = o !== 0 ? Math.max(o / 2, 0.5) : 0;
  return Math.round((t - r) * n) / n + r;
}
function jo(e, t) {
  !t && !e || (t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
function Ro(e, t, o, n) {
  st(e, t, o, n, null);
}
function st(e, t, o, n, r) {
  let i, a, s, c, l, u, p, d;
  const g = t.pointStyle, y = t.rotation, h = t.radius;
  let f = (y || 0) * Ee;
  if (g && typeof g == "object" && (i = g.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(o, n), e.rotate(f), e.drawImage(g, -g.width / 2, -g.height / 2, g.width, g.height), e.restore();
    return;
  }
  if (!(isNaN(h) || h <= 0)) {
    switch (e.beginPath(), g) {
      // Default includes circle
      default:
        r ? e.ellipse(o, n, r / 2, h, 0, 0, M) : e.arc(o, n, h, 0, M), e.closePath();
        break;
      case "triangle":
        u = r ? r / 2 : h, e.moveTo(o + Math.sin(f) * u, n - Math.cos(f) * h), f += te, e.lineTo(o + Math.sin(f) * u, n - Math.cos(f) * h), f += te, e.lineTo(o + Math.sin(f) * u, n - Math.cos(f) * h), e.closePath();
        break;
      case "rectRounded":
        l = h * 0.516, c = h - l, a = Math.cos(f + k) * c, p = Math.cos(f + k) * (r ? r / 2 - l : c), s = Math.sin(f + k) * c, d = Math.sin(f + k) * (r ? r / 2 - l : c), e.arc(o - p, n - s, l, f - x, f - w), e.arc(o + d, n - a, l, f - w, f), e.arc(o + p, n + s, l, f, f + w), e.arc(o - d, n + a, l, f + w, f + x), e.closePath();
        break;
      case "rect":
        if (!y) {
          c = Math.SQRT1_2 * h, u = r ? r / 2 : c, e.rect(o - u, n - c, 2 * u, 2 * c);
          break;
        }
        f += k;
      /* falls through */
      case "rectRot":
        p = Math.cos(f) * (r ? r / 2 : h), a = Math.cos(f) * h, s = Math.sin(f) * h, d = Math.sin(f) * (r ? r / 2 : h), e.moveTo(o - p, n - s), e.lineTo(o + d, n - a), e.lineTo(o + p, n + s), e.lineTo(o - d, n + a), e.closePath();
        break;
      case "crossRot":
        f += k;
      /* falls through */
      case "cross":
        p = Math.cos(f) * (r ? r / 2 : h), a = Math.cos(f) * h, s = Math.sin(f) * h, d = Math.sin(f) * (r ? r / 2 : h), e.moveTo(o - p, n - s), e.lineTo(o + p, n + s), e.moveTo(o + d, n - a), e.lineTo(o - d, n + a);
        break;
      case "star":
        p = Math.cos(f) * (r ? r / 2 : h), a = Math.cos(f) * h, s = Math.sin(f) * h, d = Math.sin(f) * (r ? r / 2 : h), e.moveTo(o - p, n - s), e.lineTo(o + p, n + s), e.moveTo(o + d, n - a), e.lineTo(o - d, n + a), f += k, p = Math.cos(f) * (r ? r / 2 : h), a = Math.cos(f) * h, s = Math.sin(f) * h, d = Math.sin(f) * (r ? r / 2 : h), e.moveTo(o - p, n - s), e.lineTo(o + p, n + s), e.moveTo(o + d, n - a), e.lineTo(o - d, n + a);
        break;
      case "line":
        a = r ? r / 2 : Math.cos(f) * h, s = Math.sin(f) * h, e.moveTo(o - a, n - s), e.lineTo(o + a, n + s);
        break;
      case "dash":
        e.moveTo(o, n), e.lineTo(o + Math.cos(f) * (r ? r / 2 : h), n + Math.sin(f) * h);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function se(e, t, o) {
  return o = o || 0.5, !t || e && e.x > t.left - o && e.x < t.right + o && e.y > t.top - o && e.y < t.bottom + o;
}
function Wo(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function Ao(e) {
  e.restore();
}
function Bo(e, t, o, n, r) {
  if (!t)
    return e.lineTo(o.x, o.y);
  if (r === "middle") {
    const i = (t.x + o.x) / 2;
    e.lineTo(i, t.y), e.lineTo(i, o.y);
  } else r === "after" != !!n ? e.lineTo(t.x, o.y) : e.lineTo(o.x, t.y);
  e.lineTo(o.x, o.y);
}
function Do(e, t, o, n) {
  if (!t)
    return e.lineTo(o.x, o.y);
  e.bezierCurveTo(n ? t.cp1x : t.cp2x, n ? t.cp1y : t.cp2y, n ? o.cp2x : o.cp1x, n ? o.cp2y : o.cp1y, o.x, o.y);
}
function ct(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), I(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function lt(e, t, o, n, r) {
  if (r.strikethrough || r.underline) {
    const i = e.measureText(n), a = t - i.actualBoundingBoxLeft, s = t + i.actualBoundingBoxRight, c = o - i.actualBoundingBoxAscent, l = o + i.actualBoundingBoxDescent, u = r.strikethrough ? (c + l) / 2 : l;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = r.decorationWidth || 2, e.moveTo(a, u), e.lineTo(s, u), e.stroke();
  }
}
function ut(e, t) {
  const o = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = o;
}
function No(e, t, o, n, r, i = {}) {
  const a = T(t) ? t : [
    t
  ], s = i.strokeWidth > 0 && i.strokeColor !== "";
  let c, l;
  for (e.save(), e.font = r.string, ct(e, i), c = 0; c < a.length; ++c)
    l = a[c], i.backdrop && ut(e, i.backdrop), s && (i.strokeColor && (e.strokeStyle = i.strokeColor), I(i.strokeWidth) || (e.lineWidth = i.strokeWidth), e.strokeText(l, o, n, i.maxWidth)), e.fillText(l, o, n, i.maxWidth), lt(e, o, n, l, i), n += Number(r.lineHeight);
  e.restore();
}
function Lo(e, t) {
  const { x: o, y: n, w: r, h: i, radius: a } = t;
  e.arc(o + a.topLeft, n + a.topLeft, a.topLeft, 1.5 * x, x, !0), e.lineTo(o, n + i - a.bottomLeft), e.arc(o + a.bottomLeft, n + i - a.bottomLeft, a.bottomLeft, x, w, !0), e.lineTo(o + r - a.bottomRight, n + i), e.arc(o + r - a.bottomRight, n + i - a.bottomRight, a.bottomRight, w, 0, !0), e.lineTo(o + r, n + a.topRight), e.arc(o + r - a.topRight, n + a.topRight, a.topRight, 0, -w, !0), e.lineTo(o + a.topLeft, n);
}
const ft = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, ht = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function pt(e, t) {
  const o = ("" + e).match(ft);
  if (!o || o[1] === "normal")
    return t * 1.2;
  switch (e = +o[2], o[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const dt = (e) => +e || 0;
function we(e, t) {
  const o = {}, n = m(t), r = n ? Object.keys(t) : t, i = m(e) ? n ? (a) => _(e[a], e[t[a]]) : (a) => e[a] : () => e;
  for (const a of r)
    o[a] = dt(i(a));
  return o;
}
function gt(e) {
  return we(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function zo(e) {
  return we(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function Eo(e) {
  const t = gt(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function Ho(e, t) {
  e = e || {}, t = t || it.font;
  let o = _(e.size, t.size);
  typeof o == "string" && (o = parseInt(o, 10));
  let n = _(e.style, t.style);
  n && !("" + n).match(ht) && (console.warn('Invalid font style specified: "' + n + '"'), n = void 0);
  const r = {
    family: _(e.family, t.family),
    lineHeight: pt(_(e.lineHeight, t.lineHeight), o),
    size: o,
    style: n,
    weight: _(e.weight, t.weight),
    string: ""
  };
  return r.string = at(r), r;
}
function Fo(e, t, o, n) {
  let r, i, a;
  for (r = 0, i = e.length; r < i; ++r)
    if (a = e[r], a !== void 0 && a !== void 0)
      return a;
}
function Qo(e, t, o) {
  const { min: n, max: r } = e, i = Re(t, (r - n) / 2), a = (s, c) => o && s === 0 ? 0 : s + c;
  return {
    min: a(n, -Math.abs(i)),
    max: a(r, i)
  };
}
function yt(e, t) {
  return Object.assign(Object.create(e), t);
}
function ve(e, t = [
  ""
], o, n, r = () => e[0]) {
  const i = o || e;
  typeof n > "u" && (n = Oe("_fallback", e));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: i,
    _fallback: n,
    _getTarget: r,
    override: (s) => ve([
      s,
      ...e
    ], t, i, n)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, c) {
      return delete s[c], delete s._keys, delete e[0][c], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, c) {
      return ke(s, c, () => Ot(c, t, e, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, c) {
      return Reflect.getOwnPropertyDescriptor(s._scopes[0], c);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(s, c) {
      return le(s).includes(c);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(s) {
      return le(s);
    },
    /**
    * A trap for setting property values.
    */
    set(s, c, l) {
      const u = s._storage || (s._storage = r());
      return s[c] = u[c] = l, delete s._keys, !0;
    }
  });
}
function Q(e, t, o, n) {
  const r = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: o,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: bt(e, n),
    setContext: (i) => Q(e, i, o, n),
    override: (i) => Q(e.override(i), t, o, n)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, a) {
      return delete i[a], delete e[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, a, s) {
      return ke(i, a, () => mt(i, a, s));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, a) {
      return i._descriptors.allKeys ? Reflect.has(e, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(i, a) {
      return Reflect.has(e, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(i, a, s) {
      return e[a] = s, delete i[a], !0;
    }
  });
}
function bt(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: o = t.scriptable, _indexable: n = t.indexable, _allKeys: r = t.allKeys } = e;
  return {
    allKeys: r,
    scriptable: o,
    indexable: n,
    isScriptable: H(o) ? o : () => o,
    isIndexable: H(n) ? n : () => n
  };
}
const xt = (e, t) => e ? e + ye(t) : t, X = (e, t) => m(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function ke(e, t, o) {
  if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor")
    return e[t];
  const n = o();
  return e[t] = n, n;
}
function mt(e, t, o) {
  const { _proxy: n, _context: r, _subProxy: i, _descriptors: a } = e;
  let s = n[t];
  return H(s) && a.isScriptable(t) && (s = Mt(t, s, e, o)), T(s) && s.length && (s = wt(t, s, e, a.isIndexable)), X(t, s) && (s = Q(s, r, i && i[t], a)), s;
}
function Mt(e, t, o, n) {
  const { _proxy: r, _context: i, _subProxy: a, _stack: s } = o;
  if (s.has(e))
    throw new Error("Recursion detected: " + Array.from(s).join("->") + "->" + e);
  s.add(e);
  let c = t(i, a || n);
  return s.delete(e), X(e, c) && (c = U(r._scopes, r, e, c)), c;
}
function wt(e, t, o, n) {
  const { _proxy: r, _context: i, _subProxy: a, _descriptors: s } = o;
  if (typeof i.index < "u" && n(e))
    return t[i.index % t.length];
  if (m(t[0])) {
    const c = t, l = r._scopes.filter((u) => u !== c);
    t = [];
    for (const u of c) {
      const p = U(l, r, e, u);
      t.push(Q(p, i, a && a[e], s));
    }
  }
  return t;
}
function _e(e, t, o) {
  return H(e) ? e(t, o) : e;
}
const vt = (e, t) => e === !0 ? t : typeof e == "string" ? Le(t, e) : void 0;
function kt(e, t, o, n, r) {
  for (const i of t) {
    const a = vt(o, i);
    if (a) {
      e.add(a);
      const s = _e(a._fallback, o, r);
      if (typeof s < "u" && s !== o && s !== n)
        return s;
    } else if (a === !1 && typeof n < "u" && o !== n)
      return null;
  }
  return !1;
}
function U(e, t, o, n) {
  const r = t._rootScopes, i = _e(t._fallback, o, n), a = [
    ...e,
    ...r
  ], s = /* @__PURE__ */ new Set();
  s.add(n);
  let c = ce(s, a, o, i || o, n);
  return c === null || typeof i < "u" && i !== o && (c = ce(s, a, i, c, n), c === null) ? !1 : ve(Array.from(s), [
    ""
  ], r, i, () => _t(t, o, n));
}
function ce(e, t, o, n, r) {
  for (; o; )
    o = kt(e, t, o, n, r);
  return o;
}
function _t(e, t, o) {
  const n = e._getTarget();
  t in n || (n[t] = {});
  const r = n[t];
  return T(r) && m(o) ? o : r || {};
}
function Ot(e, t, o, n) {
  let r;
  for (const i of t)
    if (r = Oe(xt(i, e), o), typeof r < "u")
      return X(e, r) ? U(o, n, e, r) : r;
}
function Oe(e, t) {
  for (const o of t) {
    if (!o)
      continue;
    const n = o[e];
    if (typeof n < "u")
      return n;
  }
}
function le(e) {
  let t = e._keys;
  return t || (t = e._keys = Tt(e._scopes)), t;
}
function Tt(e) {
  const t = /* @__PURE__ */ new Set();
  for (const o of e)
    for (const n of Object.keys(o).filter((r) => !r.startsWith("_")))
      t.add(n);
  return Array.from(t);
}
const Pt = Number.EPSILON || 1e-14, j = (e, t) => t < e.length && !e[t].skip && e[t], Te = (e) => e === "x" ? "y" : "x";
function St(e, t, o, n) {
  const r = e.skip ? t : e, i = t, a = o.skip ? t : o, s = ne(i, r), c = ne(a, i);
  let l = s / (s + c), u = c / (s + c);
  l = isNaN(l) ? 0 : l, u = isNaN(u) ? 0 : u;
  const p = n * l, d = n * u;
  return {
    previous: {
      x: i.x - p * (a.x - r.x),
      y: i.y - p * (a.y - r.y)
    },
    next: {
      x: i.x + d * (a.x - r.x),
      y: i.y + d * (a.y - r.y)
    }
  };
}
function Ct(e, t, o) {
  const n = e.length;
  let r, i, a, s, c, l = j(e, 0);
  for (let u = 0; u < n - 1; ++u)
    if (c = l, l = j(e, u + 1), !(!c || !l)) {
      if (xe(t[u], 0, Pt)) {
        o[u] = o[u + 1] = 0;
        continue;
      }
      r = o[u] / t[u], i = o[u + 1] / t[u], s = Math.pow(r, 2) + Math.pow(i, 2), !(s <= 9) && (a = 3 / Math.sqrt(s), o[u] = r * a * t[u], o[u + 1] = i * a * t[u]);
    }
}
function It(e, t, o = "x") {
  const n = Te(o), r = e.length;
  let i, a, s, c = j(e, 0);
  for (let l = 0; l < r; ++l) {
    if (a = s, s = c, c = j(e, l + 1), !s)
      continue;
    const u = s[o], p = s[n];
    a && (i = (u - a[o]) / 3, s[`cp1${o}`] = u - i, s[`cp1${n}`] = p - i * t[l]), c && (i = (c[o] - u) / 3, s[`cp2${o}`] = u + i, s[`cp2${n}`] = p + i * t[l]);
  }
}
function jt(e, t = "x") {
  const o = Te(t), n = e.length, r = Array(n).fill(0), i = Array(n);
  let a, s, c, l = j(e, 0);
  for (a = 0; a < n; ++a)
    if (s = c, c = l, l = j(e, a + 1), !!c) {
      if (l) {
        const u = l[t] - c[t];
        r[a] = u !== 0 ? (l[o] - c[o]) / u : 0;
      }
      i[a] = s ? l ? oe(r[a - 1]) !== oe(r[a]) ? 0 : (r[a - 1] + r[a]) / 2 : r[a - 1] : r[a];
    }
  Ct(e, r, i), It(e, i, t);
}
function D(e, t, o) {
  return Math.max(Math.min(e, o), t);
}
function Rt(e, t) {
  let o, n, r, i, a, s = se(e[0], t);
  for (o = 0, n = e.length; o < n; ++o)
    a = i, i = s, s = o < n - 1 && se(e[o + 1], t), i && (r = e[o], a && (r.cp1x = D(r.cp1x, t.left, t.right), r.cp1y = D(r.cp1y, t.top, t.bottom)), s && (r.cp2x = D(r.cp2x, t.left, t.right), r.cp2y = D(r.cp2y, t.top, t.bottom)));
}
function qo(e, t, o, n, r) {
  let i, a, s, c;
  if (t.spanGaps && (e = e.filter((l) => !l.skip)), t.cubicInterpolationMode === "monotone")
    jt(e, r);
  else {
    let l = n ? e[e.length - 1] : e[0];
    for (i = 0, a = e.length; i < a; ++i)
      s = e[i], c = St(l, s, e[Math.min(i + 1, a - (n ? 0 : 1)) % a], t.tension), s.cp1x = c.previous.x, s.cp1y = c.previous.y, s.cp2x = c.next.x, s.cp2y = c.next.y, l = s;
  }
  t.capBezierPoints && Rt(e, o);
}
function Wt() {
  return typeof window < "u" && typeof document < "u";
}
function At(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function q(e, t, o) {
  let n;
  return typeof e == "string" ? (n = parseInt(e, 10), e.indexOf("%") !== -1 && (n = n / 100 * t.parentNode[o])) : n = e, n;
}
const $ = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function Bt(e, t) {
  return $(e).getPropertyValue(t);
}
const Dt = [
  "top",
  "right",
  "bottom",
  "left"
];
function O(e, t, o) {
  const n = {};
  o = o ? "-" + o : "";
  for (let r = 0; r < 4; r++) {
    const i = Dt[r];
    n[i] = parseFloat(e[t + "-" + i + o]) || 0;
  }
  return n.width = n.left + n.right, n.height = n.top + n.bottom, n;
}
const Nt = (e, t, o) => (e > 0 || t > 0) && (!o || !o.shadowRoot);
function Lt(e, t) {
  const o = e.touches, n = o && o.length ? o[0] : e, { offsetX: r, offsetY: i } = n;
  let a = !1, s, c;
  if (Nt(r, i, e.target))
    s = r, c = i;
  else {
    const l = t.getBoundingClientRect();
    s = n.clientX - l.left, c = n.clientY - l.top, a = !0;
  }
  return {
    x: s,
    y: c,
    box: a
  };
}
function $o(e, t) {
  if ("native" in e)
    return e;
  const { canvas: o, currentDevicePixelRatio: n } = t, r = $(o), i = r.boxSizing === "border-box", a = O(r, "padding"), s = O(r, "border", "width"), { x: c, y: l, box: u } = Lt(e, o), p = a.left + (u && s.left), d = a.top + (u && s.top);
  let { width: g, height: y } = t;
  return i && (g -= a.width + s.width, y -= a.height + s.height), {
    x: Math.round((c - p) / g * o.width / n),
    y: Math.round((l - d) / y * o.height / n)
  };
}
function zt(e, t, o) {
  let n, r;
  if (t === void 0 || o === void 0) {
    const i = e && At(e);
    if (!i)
      t = e.clientWidth, o = e.clientHeight;
    else {
      const a = i.getBoundingClientRect(), s = $(i), c = O(s, "border", "width"), l = O(s, "padding");
      t = a.width - l.width - c.width, o = a.height - l.height - c.height, n = q(s.maxWidth, i, "clientWidth"), r = q(s.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: t,
    height: o,
    maxWidth: n || F,
    maxHeight: r || F
  };
}
const N = (e) => Math.round(e * 10) / 10;
function Ko(e, t, o, n) {
  const r = $(e), i = O(r, "margin"), a = q(r.maxWidth, e, "clientWidth") || F, s = q(r.maxHeight, e, "clientHeight") || F, c = zt(e, t, o);
  let { width: l, height: u } = c;
  if (r.boxSizing === "content-box") {
    const p = O(r, "border", "width"), d = O(r, "padding");
    l -= d.width + p.width, u -= d.height + p.height;
  }
  return l = Math.max(0, l - i.width), u = Math.max(0, n ? l / n : u - i.height), l = N(Math.min(l, a, c.maxWidth)), u = N(Math.min(u, s, c.maxHeight)), l && !u && (u = N(l / 2)), (t !== void 0 || o !== void 0) && n && c.height && u > c.height && (u = c.height, l = N(Math.floor(u * n))), {
    width: l,
    height: u
  };
}
function Vo(e, t, o) {
  const n = t || 1, r = Math.floor(e.height * n), i = Math.floor(e.width * n);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const a = e.canvas;
  return a.style && (o || !a.style.height && !a.style.width) && (a.style.height = `${e.height}px`, a.style.width = `${e.width}px`), e.currentDevicePixelRatio !== n || a.height !== r || a.width !== i ? (e.currentDevicePixelRatio = n, a.height = r, a.width = i, e.ctx.setTransform(n, 0, 0, n, 0, 0), !0) : !1;
}
const Go = (function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    Wt() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
})();
function Jo(e, t) {
  const o = Bt(e, t), n = o && o.match(/^(\d+)(\.\d+)?px$/);
  return n ? +n[1] : void 0;
}
function C(e, t, o, n) {
  return {
    x: e.x + o * (t.x - e.x),
    y: e.y + o * (t.y - e.y)
  };
}
function Yo(e, t, o, n) {
  return {
    x: e.x + o * (t.x - e.x),
    y: n === "middle" ? o < 0.5 ? e.y : t.y : n === "after" ? o < 1 ? e.y : t.y : o > 0 ? t.y : e.y
  };
}
function Xo(e, t, o, n) {
  const r = {
    x: e.cp2x,
    y: e.cp2y
  }, i = {
    x: t.cp1x,
    y: t.cp1y
  }, a = C(e, r, o), s = C(r, i, o), c = C(i, t, o), l = C(a, s, o), u = C(s, c, o);
  return C(l, u, o);
}
const Et = function(e, t) {
  return {
    x(o) {
      return e + e + t - o;
    },
    setWidth(o) {
      t = o;
    },
    textAlign(o) {
      return o === "center" ? o : o === "right" ? "left" : "right";
    },
    xPlus(o, n) {
      return o - n;
    },
    leftForLtr(o, n) {
      return o - n;
    }
  };
}, Ht = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function Uo(e, t, o) {
  return e ? Et(t, o) : Ht();
}
function Zo(e, t) {
  let o, n;
  (t === "ltr" || t === "rtl") && (o = e.canvas.style, n = [
    o.getPropertyValue("direction"),
    o.getPropertyPriority("direction")
  ], o.setProperty("direction", t, "important"), e.prevTextDirection = n);
}
function en(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function Pe(e) {
  return e === "angle" ? {
    between: Qe,
    compare: Fe,
    normalize: v
  } : {
    between: qe,
    compare: (t, o) => t - o,
    normalize: (t) => t
  };
}
function ue({ start: e, end: t, count: o, loop: n, style: r }) {
  return {
    start: e % o,
    end: t % o,
    loop: n && (t - e + 1) % o === 0,
    style: r
  };
}
function Ft(e, t, o) {
  const { property: n, start: r, end: i } = o, { between: a, normalize: s } = Pe(n), c = t.length;
  let { start: l, end: u, loop: p } = e, d, g;
  if (p) {
    for (l += c, u += c, d = 0, g = c; d < g && a(s(t[l % c][n]), r, i); ++d)
      l--, u--;
    l %= c, u %= c;
  }
  return u < l && (u += c), {
    start: l,
    end: u,
    loop: p,
    style: e.style
  };
}
function Qt(e, t, o) {
  if (!o)
    return [
      e
    ];
  const { property: n, start: r, end: i } = o, a = t.length, { compare: s, between: c, normalize: l } = Pe(n), { start: u, end: p, loop: d, style: g } = Ft(e, t, o), y = [];
  let h = !1, f = null, b, P, R;
  const Se = () => c(r, R, b) && s(r, R) !== 0, Ce = () => s(i, b) === 0 || c(i, R, b), Ie = () => h || Se(), je = () => !h || Ce();
  for (let S = u, Z = u; S <= p; ++S)
    P = t[S % a], !P.skip && (b = l(P[n]), b !== R && (h = c(b, r, i), f === null && Ie() && (f = s(b, r) === 0 ? S : Z), f !== null && je() && (y.push(ue({
      start: f,
      end: S,
      loop: d,
      count: a,
      style: g
    })), f = null), Z = S, R = b));
  return f !== null && y.push(ue({
    start: f,
    end: p,
    loop: d,
    count: a,
    style: g
  })), y;
}
function tn(e, t) {
  const o = [], n = e.segments;
  for (let r = 0; r < n.length; r++) {
    const i = Qt(n[r], e.points, t);
    i.length && o.push(...i);
  }
  return o;
}
function qt(e, t, o, n) {
  let r = 0, i = t - 1;
  if (o && !n)
    for (; r < t && !e[r].skip; )
      r++;
  for (; r < t && e[r].skip; )
    r++;
  for (r %= t, o && (i += r); i > r && e[i % t].skip; )
    i--;
  return i %= t, {
    start: r,
    end: i
  };
}
function $t(e, t, o, n) {
  const r = e.length, i = [];
  let a = t, s = e[t], c;
  for (c = t + 1; c <= o; ++c) {
    const l = e[c % r];
    l.skip || l.stop ? s.skip || (n = !1, i.push({
      start: t % r,
      end: (c - 1) % r,
      loop: n
    }), t = a = l.stop ? c : null) : (a = c, s.skip && (t = c)), s = l;
  }
  return a !== null && i.push({
    start: t % r,
    end: a % r,
    loop: n
  }), i;
}
function on(e, t) {
  const o = e.points, n = e.options.spanGaps, r = o.length;
  if (!r)
    return [];
  const i = !!e._loop, { start: a, end: s } = qt(o, r, i, n);
  if (n === !0)
    return fe(e, [
      {
        start: a,
        end: s,
        loop: i
      }
    ], o, t);
  const c = s < a ? s + r : s, l = !!e._fullLoop && a === 0 && s === r - 1;
  return fe(e, $t(o, a, c, l), o, t);
}
function fe(e, t, o, n) {
  return !n || !n.setContext || !o ? t : Kt(e, t, o, n);
}
function Kt(e, t, o, n) {
  const r = e._chart.getContext(), i = he(e.options), { _datasetIndex: a, options: { spanGaps: s } } = e, c = o.length, l = [];
  let u = i, p = t[0].start, d = p;
  function g(y, h, f, b) {
    const P = s ? -1 : 1;
    if (y !== h) {
      for (y += c; o[y % c].skip; )
        y -= P;
      for (; o[h % c].skip; )
        h += P;
      y % c !== h % c && (l.push({
        start: y % c,
        end: h % c,
        loop: f,
        style: b
      }), u = b, p = h % c);
    }
  }
  for (const y of t) {
    p = s ? p : y.start;
    let h = o[p % c], f;
    for (d = p + 1; d <= y.end; d++) {
      const b = o[d % c];
      f = he(n.setContext(yt(r, {
        type: "segment",
        p0: h,
        p1: b,
        p0DataIndex: (d - 1) % c,
        p1DataIndex: d % c,
        datasetIndex: a
      }))), Vt(f, u) && g(p, d - 1, y.loop, u), h = b, u = f;
    }
    p < d - 1 && g(p, d - 1, y.loop, u);
  }
  return l;
}
function he(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function Vt(e, t) {
  if (!t)
    return !1;
  const o = [], n = function(r, i) {
    return Y(i) ? (o.includes(i) || o.push(i), o.indexOf(i)) : i;
  };
  return JSON.stringify(e, n) !== JSON.stringify(t, n);
}
function L(e, t, o) {
  return e.options.clip ? e[o] : t[o];
}
function Gt(e, t) {
  const { xScale: o, yScale: n } = e;
  return o && n ? {
    left: L(o, t, "left"),
    right: L(o, t, "right"),
    top: L(n, t, "top"),
    bottom: L(n, t, "bottom")
  } : t;
}
function nn(e, t) {
  const o = t._clip;
  if (o.disabled)
    return !1;
  const n = Gt(t, e.chartArea);
  return {
    left: o.left === !1 ? 0 : n.left - (o.left === !0 ? 0 : o.left),
    right: o.right === !1 ? e.width : n.right + (o.right === !0 ? 0 : o.right),
    top: o.top === !1 ? 0 : n.top - (o.top === !0 ? 0 : o.top),
    bottom: o.bottom === !1 ? e.height : n.bottom + (o.bottom === !0 ? 0 : o.bottom)
  };
}
export {
  Ao as $,
  bo as A,
  A as B,
  se as C,
  go as D,
  Eo as E,
  to as F,
  Ko as G,
  w as H,
  At as I,
  Jo as J,
  Go as K,
  wo as L,
  Wt as M,
  so as N,
  Ut as O,
  x as P,
  eo as Q,
  Qo as R,
  J as S,
  M as T,
  ho as U,
  Co as V,
  yo as W,
  Io as X,
  Wo as Y,
  No as Z,
  Mo as _,
  Fo as a,
  Bt as a$,
  Ho as a0,
  ko as a1,
  _o as a2,
  ot as a3,
  E as a4,
  ye as a5,
  nt as a6,
  H as a7,
  Q as a8,
  ve as a9,
  Uo as aA,
  Zo as aB,
  Oo as aC,
  en as aD,
  st as aE,
  ne as aF,
  Yt as aG,
  uo as aH,
  ao as aI,
  lo as aJ,
  xe as aK,
  po as aL,
  et as aM,
  be as aN,
  me as aQ,
  Y as aR,
  V as aS,
  z as aT,
  We as aU,
  Be as aV,
  De as aX,
  at as aY,
  St as aZ,
  jt as a_,
  bt as aa,
  Ae as ab,
  Xt as ac,
  vo as ad,
  Vo as ae,
  jo as af,
  ro as ag,
  nn as ah,
  oo as ai,
  io as aj,
  qe as ak,
  v as al,
  we as am,
  qo as an,
  on as ao,
  tn as ap,
  Yo as aq,
  Xo as ar,
  C as as,
  Bo as at,
  Do as au,
  Ro as av,
  Lo as aw,
  gt as ax,
  zo as ay,
  Qt as az,
  T as b,
  pt as b1,
  ze as b2,
  F as b3,
  Ee as b4,
  k as b5,
  te as b6,
  Fe as b7,
  So as c,
  it as d,
  K as e,
  Le as f,
  de as g,
  no as h,
  m as i,
  yt as j,
  I as k,
  xo as l,
  Zt as m,
  Re as n,
  Xe as o,
  Qe as p,
  To as q,
  $e as r,
  oe as s,
  fo as t,
  mo as u,
  _ as v,
  Po as w,
  co as x,
  $o as z
};
//# sourceMappingURL=index.es272.js.map
